import React from 'react';
const testimonials = [{
  initials: 'VM',
  name: 'Valentina M.',
  location: 'Buenos Aires · Bajó 4 kg en 7 días',
  quote: 'Entré en cetosis en 4 días y bajé 4 kilos en la primera semana. Las recetas son con cosas del almacén de la esquina, no inventos raros.'
}, {
  initials: 'MR',
  name: 'Marcelo R.',
  location: 'Córdoba · Bajó 7 kg en 21 días',
  quote: 'Llevo 21 días y bajé 7 kilos. Lo mejor es que comí asado todos los domingos sin culpa.'
}, {
  initials: 'DP',
  name: 'Daniela P.',
  location: 'Rosario · Primera dieta sostenida',
  quote: 'Probé mil dietas. Esta es la primera que puedo sostener porque la comida es real, argentina, de todos los días.'
}];
const painPoints = ['Probás keto con recetas gringas que no te representan', 'Comprás ingredientes caros que nunca más usás', 'El día 4 te morís de hambre y abandonás', 'La gripe keto te aplasta porque nadie te avisó', 'Te perdés el asado del domingo porque "no podés"', 'Volvés al punto cero el lunes siguiente'];
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-[#F5F1E8]" data-id="element-127">
      <div className="max-w-6xl mx-auto px-4" data-id="element-128">
        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-6 mb-20 md:mb-28" data-id="element-129">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-green-100 rounded-2xl p-6 hover:border-green-300 transition-colors shadow-sm" data-id="element-130">
              <div className="flex items-center gap-3 mb-4" data-id="element-131">
                <div className="w-11 h-11 rounded-full bg-green-50 text-green-600 flex items-center justify-center font-bold text-sm border border-green-200" data-id="element-132">
                  {t.initials}
                </div>
                <div data-id="element-133">
                  <div className="text-green-600 text-xs tracking-wider mb-0.5" data-id="element-134">
                    ★★★★★
                  </div>
                  <div className="text-sm text-slate-600 font-medium" data-id="element-135">
                    {t.name}
                  </div>
                </div>
              </div>
              <p className="text-slate-700 italic leading-relaxed text-sm md:text-base" data-id="element-136">
                "{t.quote}"
              </p>
              <div className="mt-4 text-xs text-slate-500 font-medium" data-id="element-137">
                {t.location}
              </div>
            </div>)}
        </div>

        {/* Pain Points */}
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-12" data-id="element-138">
          <h2 className="text-3xl md:text-5xl font-bold text-green-900 mb-6 leading-tight" data-id="element-139">
            ¿Cuántos lunes más vas a empezar de cero?
          </h2>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed" data-id="element-140">
            Querés bajar de peso. Lo sabés. Y no es que no tengas ganas. Pero
            cada vez que intentás arrancar pasa lo mismo: las recetas piden
            harina de almendras imposible, el plan es para otro país, el día 4
            extrañás el pan y el domingo del asado todo se va al diablo.
          </p>
          <p className="text-lg md:text-xl text-green-600 font-semibold mt-6" data-id="element-141">
            No es falta de voluntad. Es falta de un sistema hecho para
            Argentina.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-white border border-green-100 rounded-2xl md:rounded-3xl p-6 md:p-10 shadow-md" data-id="element-142">
          <div className="space-y-5" data-id="element-143">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3 md:gap-4" data-id="element-144">
                <span className="text-red-500 text-lg mt-0.5 shrink-0" data-id="element-145">❌</span>
                <p className="text-base md:text-lg text-slate-700" data-id="element-146">{point}</p>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12 md:mt-16" data-id="element-147">
          <h3 className="text-2xl md:text-4xl font-bold text-green-900" data-id="element-148">
            ¿Y si este fuera el último lunes que empezás así?
          </h3>
        </div>
      </div>
    </section>;
}